import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfiguration } from '../../core/models/app-configuration.model';
import { ContactRequest, ContactResponse } from '../model/contacts.model';
import { createRequestOption, SearchWithPagination } from '../util/request-util';

type ContactResponseType = HttpResponse<ContactResponse>;

/**
 * Contacts Service
 * @description Angular Service class with method used for create, update, delete and query the contacts API
 */

@Injectable({ providedIn: 'root' })
export class ContactsService {
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfiguration) { }

  getResourceUrl(): string {
    return this.appConfig.serverApiUrl + '/api/v1/contacts';
  }

  /**
   * Get a list of contacts. The request accept key,value filters
   * @param req Filters object @see SearchWithPagination
   */
  query(req?: SearchWithPagination): Observable<HttpResponse<ContactResponse[]>> {
    const options = createRequestOption(req);
    return this.http.get<ContactResponse[]>(this.getResourceUrl(), { params: options, observe: 'response' });
  }

  /**
   * Create a new contact
   *
   * @param authReqId The required authorization request ID @see AuthorizationService
   * @param req  Object contains new contact information @see ContactRequest
   */
  save(authReqId: string, req: ContactRequest): Observable<ContactResponse> {
    return this.http.put<ContactResponse>(this.getResourceUrl(), req, {
      headers: new HttpHeaders({ authPermission: authReqId }),
    });
  }
  save2fa(authReqId: string, req: ContactRequest): Observable<ContactResponse> {
    return this.http.put<ContactResponse>(this.getResourceUrl() + '/2fa', req, {
      headers: new HttpHeaders({ authPermission: authReqId }),
    });
  }
}
